// extracted by mini-css-extract-plugin
module.exports = {"loader":"Spinner_loader__2SlOg","spin":"Spinner_spin__3E0Hf","container":"Spinner_container__3Yvx1"};